import { Component, EventEmitter, Input, OnInit, Output, ViewChild, TemplateRef } from "@angular/core";
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { MascaraCnaePermitido } from "src/app/model/mascara-cnae-permitido.model";
import Utils from "src/app/shared/fgi-utils";
import { Observable } from "rxjs";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { CnaePermitidoService } from '../../cnae-permitido.service';
import { CnaePermitidoPesquisaComponent } from '../cnae-permitido-pesquisa.component';
import { MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";

@Component({
    selector: 'app-cnae-permitido-listagem',
    templateUrl: './cnae-permitido-listagem.component.html',
    styleUrls: ['./cnae-permitido-listagem.component.scss'],
    standalone: false
})
export class CnaePermitidoListagemComponent {

  @Input() cnaesPermitidos: MascaraCnaePermitido[];
  @Input() msgSemResultado: boolean = false;
  @Input() atributosPaginacao: EntityPagedRequestParameters;
  @Input() podeCadastrarEncerrar: boolean = true;
  @Input() dataHoraResultado: string;
  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Output() public exportarCnaesPermitidos: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('botoes') botoesPersonalizados: TemplateRef<any>;
  @ViewChild('body') msgPersonalizada: TemplateRef<any>;
  private cnaeDesativando: MascaraCnaePermitido;
  private tomorrow: string;
  public justificativa: string;

  public opcoesPaginacao: number[] = [10, 15, 20];
  public atributosOrdenacao: EntityOrderedRequestParameters;
  public rowHovered: number | null = null;

  constructor(private modalService: BnModalMessageService,
    private cnaePermitidoService: CnaePermitidoService,
    private CnaePermitidoPesquisaComponent: CnaePermitidoPesquisaComponent,
    private messageService: MessageChannelService,) {}

  ngOnInit() {
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    let funcao = undefined;
    if (ord.atributo == 'valor') {
      funcao = parseFloat;
    }
    this.cnaesPermitidos = this.cnaesPermitidos.sort((a, b) => {
      if (ord.sentido == "asc") {
          return Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
      else {
          return -1 * Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
    });
  }

  private compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) == this.fetchFromObject(b, atributo)) {
      return 0;
    }
    else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      }
      else {
        return -1;
      }
    }
  }

  private fetchFromObject(obj, prop) {

    if(typeof obj === 'undefined') {
      return false;
    }

    var _index = prop.indexOf('.')
    if(_index > -1) {
        return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  btnExportarCnaes() {
    this.exportarCnaesPermitidos.emit(null);
  }

  hover(index: number) {
    this.rowHovered = index;
  }

  hoverClean() {
    this.rowHovered = null;
  }

  abrirModal(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean) {
    if (hasBotoes === true && hasMsgTemplate === true) {
      this.modalService.abrir('Confirmação: encerrar vigência da permissão', msg, tamanho, this.msgPersonalizada, this.botoesPersonalizados);
    }
  }

  public salvar() {
    let dto: any = {};
    if(this.justificativa) {
      dto.justificativa = this.justificativa;
    }
    this.cnaePermitidoService.encerrarVigenciaCnaePermissao(this.cnaeDesativando.id, dto.justificativa).subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Máscara de CNAE encerrada com sucesso e não estará mais ativa a partir do próximo dia.'
      })
      this.close();
      this.CnaePermitidoPesquisaComponent.buscar(false);
    })
  }

  public encerrarVigencia(ideMascaraCnaeImpedido: number) {
    this.getCnaePorId(ideMascaraCnaeImpedido);
    this.getTomorrow();

    if(this.cnaeDesativando) {
      this.modalService.abrir('Confirma encerrar a vigência?', 'Modal com body sendo uma template', 'lg', this.msgPersonalizada, this.botoesPersonalizados);
    }
  }

  private getCnaePorId(ideMascaraCnaeImpedido: number) {
    this.cnaesPermitidos.forEach((e) => {
      if(e.id == ideMascaraCnaeImpedido) {
        this.cnaeDesativando = e;
      }
    });
  }

  private getTomorrow() {
    var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    var day = currentDate.getDate();
    var month = currentDate.getMonth() + 1;
    var year = currentDate.getFullYear();
    this.tomorrow = day + "/" + month + "/" + year;
  }

  async abreModalConfirmacao(mensagem: string): Promise<boolean> {
    const titulo = 'Confirmação';

    try {
      const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
      return resultadoConfimacao.value === 'ok';
    } catch (e) {
      return false;
    }
  }

  close() {
    this.modalService.close();
  }
}
